export default "__VITE_ASSET__91feb5f6__"